import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSupabaseClient } from '@supabase/auth-helpers-react';

export function useMenuTitle() {
  const [title, setTitle] = useState('');
  const location = useLocation();
  const supabase = useSupabaseClient();

  useEffect(() => {
    fetchMenuTitle();

    // Subscribe to menu_items changes
    const menuItemsChannel = supabase
      .channel('menu_items_title_changes')
      .on(
        'postgres_changes',
        {
          event: '*', // Listen for all events (INSERT, UPDATE, DELETE)
          schema: 'public',
          table: 'menu_items',
          filter: `path=eq.${location.pathname}` // Only listen for changes to current path
        },
        (payload) => {
          if (payload.eventType === 'DELETE') {
            setTitle(''); // Clear title if menu item is deleted
          } else {
            setTitle(payload.new.name); // Update title directly from payload
          }
        }
      )
      .subscribe();

    // Cleanup subscription
    return () => {
      menuItemsChannel.unsubscribe();
    };
  }, [location.pathname]); // Re-run when path changes

  async function fetchMenuTitle() {
    try {
      const { data, error } = await supabase
        .from('menu_items')
        .select('name')
        .eq('path', location.pathname)
        .single();

      if (error) {
        console.error('Error fetching menu title:', error);
        return;
      }

      if (data) {
        setTitle(data.name);
      } else {
        setTitle('Menu Management');
      }
    } catch (error) {
      console.error('Error in fetchMenuTitle:', error);
      setTitle('Menu Management');
    }
  }

  return title || 'Menu Management';
}
